import React from "react";
import styles from "./styles.module.css";

export default function InputCard({
  key,
  title,
  placeholder,
  component,
  alturaMenuOpen,
  value,
  wl,
  ...restProps
}) {
  // Se o valor vier como "R$ 123,45", separe o cifrão do valor
  let symbol = "";
  let money = value;
  if (typeof value === "string" && value.trim().startsWith("R$")) {
    [symbol, money] = value.split(/\s(.+)/); // separa "R$" e o resto
  }


const corTema = wl?.cor_tema_primaria || "gray";
  return (
    <div className={styles["input-card"]} style={{ height: 70 + alturaMenuOpen }}>
      <label htmlFor={title}>{title}</label>
      {component ? (
      React.cloneElement(component, { name, ...restProps })
      ) : (
        <div className={styles.moneyInputWrapper}>
          {symbol && <span className={styles.cifrao}>{symbol}</span>}
          <input
            type="text"
            id={title}
            placeholder={placeholder ?? ""}
            value={money}
            {...restProps}
            className={styles.moneyInput}
            style={{
              color: corTema,
            }}
          />
        </div>
      )}
    </div>
  );
}
